import classNames from "classnames";
import {
  GameOption,
  Question,
  QuestionStatus,
} from "../../game-state/game-state.type";
import { OptionImage } from "./option-image";
import { useAppDispatch } from "../../../app/hooks";
import { playSound } from "../../game-state/games.functions";

export const OptionGrid = (props: {
  currentQuestion: Question;
  currentQuestionStatus: QuestionStatus;
  options: Record<string, GameOption>;
  provideAnswer: (option: string) => void;
}) => {
  const dispatch = useAppDispatch();
  return (
    <div className="flex flex-wrap justify-center py-4">
      {props.currentQuestion.options.map((option) => (
        <div
          onMouseEnter={() => {
            if (props.currentQuestionStatus === "not-answered") {
              dispatch(playSound("sfx/select.mp3", undefined, 0.25));
            }
          }}
          className={classNames(
            "p-3 sm:p-4 rounded m-2 sm:m-4 transform transition duration-200 border-4 border-white",
            {
              "bg-white hover:scale-105 hover:bg-yellow-400 cursor-pointer":
                props.currentQuestionStatus === "not-answered",
              "bg-green-500 scale-105":
                props.currentQuestionStatus === "answered" &&
                option === props.currentQuestion.correctOption,
              "bg-red-500 scale-100":
                props.currentQuestionStatus === "answered" &&
                option !== props.currentQuestion.correctOption,
            }
          )}
          key={option}
          onClick={() => {
            if (props.currentQuestionStatus === "not-answered") {
              props.provideAnswer(option);
            }
          }}
        >
          <div className="w-32 sm:w-40 lg:w-60">
            <OptionImage option={props.options[option]} />
          </div>
        </div>
      ))}
    </div>
  );
};
